import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import omit from 'lodash/omit'

import Select from 'modules/core/components/Inputs/Select'
import { SelectProps } from 'modules/core/components/Inputs/types'
import Loading from 'modules/core/components/Loading'
// TODO: Make async and only load your current locale
import countryList from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

type Props = Omit<SelectProps, 'missingLabel' | 'selectValue'> & {
  extraCountries?: SelectOption[]
}

const Country = (props: Props) => {
  const { extraCountries } = props
  const list = countryList[i18n.locale as keyof typeof countryList] || countryList.en

  if (!list) return <Loading />

  return (
    <Select
      {...omit(props, ['none'])}
      none={props.none || i18n.t('common.choose')}
      options={extraCountries ? [...extraCountries, ...list] : list}
      showOriginalLabelText
    />
  )
}

export default Country
